import authInstance from "../Interceptor";

export const AddBarClubEffect = (data, config) => {
  return authInstance.post("/bars/insertbar", data, config);
};

export const EditBarClubEffect = (BarClubId, updatedData) => {
  return authInstance.put(`/bars/updatebar/${BarClubId}`, updatedData);
};

export const DeleteBarClubEffect = (BarClubId) => {
  return authInstance.delete(`/bars/delete/${BarClubId}`);
};

export const ViewBarClubEffect = (BarClubId) => {
  return authInstance.get(`/bars/getbar?bar_id=${BarClubId}`);
};

export const ViewAllBarClubEffect = (payload) => {
  return authInstance.get(
    `/bars/list?pagination_required=true&pagesize=10&pageNo=${payload.pageNo}&search_key=${payload.search_key}`
  );
};

export const ViewAllSearchBarClubEffect = () => {
  return authInstance.get(`/bars/list`);
};

export const ViewAllBarClubByWholesalerIdEffect = (wholesalerId, pageNo, search_key) => {
  return authInstance.get(
    `/wholesalers/getBarbyWholesaler?wholesaler_id=${wholesalerId}&pageNo=${pageNo}&search_key=${search_key}&pagesize=10&pagination_required=true`
  );
};

export const ViewAllSearchBarClubByWholesalerIdEffect = (wholesalerId) => {
  return authInstance.get(
    `/wholesalers/getBarbyWholesaler?wholesaler_id=${wholesalerId}`
  );
};
